import tippy from "tippy.js";

class TWFormTooltips {
  init() {
    const $icons = document.querySelectorAll(".info-tooltip");
    $icons &&
      tippy($icons, {
        theme: "thewave",
        offset: [0, 10],
        allowHTML: true,
      });
  }
}

window.addEventListener("DOMContentLoaded", () => {
  new TWFormTooltips().init();
});
